import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'

import { FlxClickStopPropagationDirective } from '@flowx/designer/modules/core/directives/stop-propagation.directive'
import { AiIconsModule } from '@flowx/designer/modules/new-ai/common/icons/ai-icons.module'

import { AiActionFlavor } from './ai-action-button.types'

@Component({
  selector: 'flx-ai-action-button',
  templateUrl: './ai-action-button.component.html',
  styleUrls: ['./ai-action-button.component.scss'],
  imports: [AiIconsModule, CommonModule, FlxClickStopPropagationDirective],
})
export class AiButtonComponent {
  @Input() label: string
  @Input() disabled = false
  @Input() flavor: AiActionFlavor
  @Input() iconName: string
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>()
  flavorToClass: { [key in AiActionFlavor]: string } = {
    dark: 'bg-neutral-700 text-white',
    light: 'bg-neutral-200 text-black',
    accept: 'bg-green-400 text-white',
    discard: 'bg-red-400 text-white',
  }
}
